/**
 * What happens when a boss dies mid-run. Kept pure so the sequencing is
 * unit-testable without booting Game. `index` is the gauntletIndex of the boss
 * just killed; `endIndex` is the act's own end (data/acts.js).
 *
 * Returns:
 *  - 'end'     — the run is over (an Endless loop boundary, which offers
 *                Continue; or the act's final boss).
 *  - 'advance' — go straight to the next boss's wave stage.
 *
 * Every act is standalone now. Act I finishes on the Unmade King, Act II on the
 * Undersong, Act III on the Anthem, and each walks only from its own startIndex
 * to its own endIndex. That retires the old 'descend' outcome — Act I falling
 * through the King into Act II as one thirteen-boss run — and with it the
 * `descends` flag Act III needed purely to opt out of it: nothing descends now,
 * so nothing has to ask not to.
 *
 * Endless is unchanged: it loops Act I and ends at every Act I final-boss
 * boundary, which is the only reason `actOneLen` is still a parameter.
 */
export function bossDeathOutcome({ endless, index, actOneLen, endIndex }) {
  if (endless) return index % actOneLen >= actOneLen - 1 ? 'end' : 'advance';
  return index >= endIndex - 1 ? 'end' : 'advance';
}
